import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { Copy } from '@grubhubprod/gh-cookbook-react';
import { CookbookSegmentedControlWrapper } from 'src/components/CookbookSegmentedControlWrapper/CookbookSegmentedControlWrapper';
import { getYesAndNoOptions } from 'src/components/oneCorp/features/MealCredit/common/formFields/mealCreditFormFields.utils';
import { CustomLabelWithTooltip } from 'src/components/common/CustomLabelWithTooltip/CustomLabelWithTooltip';

export interface EmailNotificationSegmentedControlProps {
  name: string;
  id: string;
}

export function EmailNotificationSegmentedControl({
  name,
  id,
}: EmailNotificationSegmentedControlProps): JSX.Element {
  const { control } = useFormContext();

  return (
    <CookbookSegmentedControlWrapper
      id={id}
      control={control}
      width="100%"
      label={
        <CustomLabelWithTooltip
          labelText="Send email when credit becomes available?"
          tooltipInfo={
            <Copy variant="body" color="invertedPrimaryText">
              Employees assigned to this meal credit will receive an email
              notification the morning it becomes available. Those added to an
              existing meal credit will receive the email the morning after
              they're added.
            </Copy>
          }
        />
      }
      name={name}
      defaultValue="No"
      options={getYesAndNoOptions(id)}
    />
  );
}
